import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("etf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Silent refresh: saat access token kedaluwarsa (401), tukar refresh cookie -> token baru,
// lalu ulang request. User tidak ter-logout sampai dia logout sendiri / refresh token habis.
const AUTH_HANDSHAKE = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/forgot", "/auth/reset", "/auth/logout"];
let isRefreshing = false;
let pendingQueue = [];
const processQueue = (error, token = null) => {
  pendingQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  pendingQueue = [];
};
const PUBLIC_PATHS = ["/login", "/forgot-password", "/reset-password"];
const forceLogin = () => {
  localStorage.removeItem("etf_token");
  if (typeof window !== "undefined" && !PUBLIC_PATHS.includes(window.location.pathname)) {
    window.location.assign("/login");
  }
};

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error?.response?.status;
    const url = original.url || "";
    if (status !== 401 || AUTH_HANDSHAKE.some((p) => url.includes(p))) {
      return Promise.reject(error);
    }
    if (original._retry) { forceLogin(); return Promise.reject(error); }

    if (isRefreshing) {
      return new Promise((resolve, reject) => pendingQueue.push({ resolve, reject }))
        .then((token) => {
          original._retry = true;
          if (token) original.headers.Authorization = `Bearer ${token}`;
          return api(original);
        });
    }

    original._retry = true;
    isRefreshing = true;
    try {
      const { data } = await api.post("/auth/refresh");
      const newToken = data?.access_token;
      if (newToken) localStorage.setItem("etf_token", newToken);
      processQueue(null, newToken);
      if (newToken) original.headers.Authorization = `Bearer ${newToken}`;
      return api(original);
    } catch (refreshErr) {
      processQueue(refreshErr, null);
      forceLogin();
      return Promise.reject(refreshErr);
    } finally {
      isRefreshing = false;
    }
  }
);

export function getToken() {
  return localStorage.getItem("etf_token");
}

export function fileUrl(fileId) {
  return `${API}/files/${fileId}?auth=${encodeURIComponent(getToken() || "")}`;
}

export function exportUrl(params = {}) {
  const qp = new URLSearchParams();
  qp.set("auth", getToken() || "");
  Object.entries(params).forEach(([k, v]) => { if (v) qp.set(k, v); });
  return `${API}/export/excel?${qp.toString()}`;
}

export function reportExportUrl(kind, params = {}) {
  const qp = new URLSearchParams();
  qp.set("auth", getToken() || "");
  Object.entries(params).forEach(([k, v]) => { if (v) qp.set(k, v); });
  return `${API}/reports/${kind}/export?${qp.toString()}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
